import {organisationConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { editRelationLoading : true, data: '', error: false};

export function orgEditRelation(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_ORG_EDIT_RELATION:
        return {
          editRelationLoading: true,
          data: action.data,
          error: false
        };
      case organisationConstants.RECEIVE_ORG_EDIT_RELATION:
      swal({
        text: 'Relations Updated Successfully',
        type: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
        return {
          editRelationLoading: false,
          data: action.relation,
          error: false
        };
      case organisationConstants.ORG_EDIT_RELATION_ERROR:
        return { 
          editRelationLoading: false,
          data: action.error,
          error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/editRelation.reducer.js